import {
    AUTO_CHANGE_NAVIGATE_STAUTS,
    CHANG_ZYK_SEARCH_TEXT,
    CHANGE_NAVIGATE,
    CHANGE_NAVIGATE_STAUTS,
    LOAD_NAVIGATE_DATA,
    REFRESH_PAGE,
    SHRIN_NAVIGATE_STAUTS,
    UPDATE_NAVIGATE_DATA,
    ZYK_STORY_COUNT,
    ZYK_PICTURE_COUNT,
    ZYK_AUDIO_COUNT,
    ZYK_VIDEO_COUNT,
    ZYK_DOCUMENT_COUNT,
    UPDATE_NAVIGATE_LEVEL2_DATA,
    UN_READ_MESSAGE_COUNT,
    CONTENT_PICTURE_COUNT,
    SYSTEM_STATUS,
    LOAD_CURRENT_USER, LOAD_SYSTEM_CONFIG
} from "../constants";
import {applicationName, uuid} from "../utils";
import "isomorphic-fetch";
import config from "../config";
import $ from 'jquery';
import {message} from 'antd';
import request from "../base/request";

export const headers = {
    "Pragma": 'no-cache',
    'Cache-Control': 'no-cache',
    'Content-Type': 'application/x-www-form-urlencoded',

};
export const bodyHeader = {
    "Pragma": 'no-cache',
    'Cache-Control': 'no-cache',
    "Content-Type": 'application/json;charset=UTF-8'

};

export const headerJson = {
    "Pragma": 'no-cache',
    'Cache-Control': 'no-cache',
    'Content-Type': 'application/json;charset=UTF-8',
};
export const getManuscriptQuantity = (params) => {
    let url = `/cm-sites-${process.env.REACT_APP_NAME}/manuscriptQuantity/getManuscriptQuantity?deptIds=${params.deptIds}`;
    if (params.startDate) {
        url += `&startDate=${params.startDate}`;
    }
    if (params.endDate) {
        url += `&endDate=${params.endDate}`;
    }
    const init = {
        headers: headers,
        cache: "no-cache",
        credentials: "include"
    };
    return fetch(url, init).then(response => response.json());
};

export const changeNavigate = uid => dispatch => dispatch({type: CHANGE_NAVIGATE, menuId: uid});

export const changeLoginStatus = (systemStatus) => ({type: SYSTEM_STATUS, systemStatus});

export const loadCurrentUser = (callBack, errorCallBack) => dispatch => {
    request({url:`/cm-sites-sys/user/getCurrentUser`, callBack:(data)=>{
            dispatch({type: LOAD_CURRENT_USER,currentUser: data});
            callBack&&callBack(data);
        }, message:{info:errorCallBack, error:errorCallBack}});
};

export const loadSystemConfigList = (callBack, errorCallBack) => dispatch => {
    let url = "/cm-sites-sys/config/getAll";
    request({url,method:'post',contentType:'json', callBack:(data)=>{
            callBack(data);
            dispatch({
                type: LOAD_SYSTEM_CONFIG,
                config: (()=>{
                    return data;
                })()
            });
        }, message:{info:errorCallBack, error:errorCallBack}});
};
export const loadNavigateData = () => dispatch => request({
    url:`/cm-sites-sys/menu/findUserMenuTree?clientType=0`,
    callBack:Data => {
        let data=Data.child;//因为获取的是全部的菜单，所以这个要获取纯菜单，所以取第一级
        setInfoToLocalStorage("menu", data);
        let path = window.location;
        try {
            path = path.hash.replace("#", "")
        } catch (e) {
            path = "/";
        }
        for (let i = 0; data && i < data.length; i++) {//跟每一个导航设置一个id，方便进行获取
            let one = data[i];
            if (!one.id) one.id = uuid();
            if(path==='/'&&(one.menuName==='工作桌面'||one.menuName==='我的桌面')){//这块针对清华菜单做的优化，工作桌面默认选中
                one.check = true;
            }
            if (path !== "/") {
                //注意，这块儿要埋雷了，实在没办法了。浮窗中的所有路径必须是以浮窗的item的prev开始的。
                //只管一个媒体的时候，网站微信微博不是以浮窗的形式进行展现的。所以还得再判断一下子元素
                if (one.path === path || (one.prev && (path === one.prev || path.startsWith(one.prev + "/")))) {//如果当前路径是以浮窗的路径开始的，那么就说明是这个浮窗下的路径
                    one.check = true;
                    one.status = "down";
                } else {
                    one.check = false;
                    one.status = "up";
                }
            }
            for (let j = 0; one.float_ && j < one.float_.length; j++) {
                let floatItem = one.float_[j];
                //注意，这块儿要埋雷了，实在没办法了。浮窗中的所有路径必须是以浮窗的item的prev开始的。
                if(floatItem.prev && (path === floatItem.prev || path.startsWith(floatItem.prev + "/"))){//如果当前路径是以浮窗的路径开始的，那么就说明是这个浮窗下的路径
                    one.check = true;
                    one.status = "down";

                    floatItem.check = true;
                    floatItem.status = "down";
                }
            }
            for (let j = 0; one.child && j < one.child.length; j++) {
                let two = one.child[j];
                if (!two.id) two.id = uuid();
                if (path !== "/") {
                    if(two.check){//如果二级导航是默认选中的，那就要选中
                        two.check = true;
                        two.status = "down";
                    }
                    if (two.path === path){
                        two.check = true;
                        two.status = "down";

                        one.check = true;
                        one.status = "down";
                    } else {
                        two.check = false;
                        two.status = "up";
                    }
                }
                if(changeNodeStatus(two, path)){
                    one.check = true;
                    one.status = "down";
                }
            }
        }

        let addParentObject = (arr, parent=null)=>{
            for(let i = 0; arr && i < arr.length; i++){
                let item = arr[i];
                item.parent = parent;
                if(item.child && item.child.length > 0){
                    addParentObject(item.child, item);
                }
            }
        };

        let removeParentObject = (arr, parent=null)=>{
            for(let i = 0; arr && i < arr.length; i++){
                let item = arr[i];
                delete item.parent;
                if(item.child && item.child.length > 0){
                    removeParentObject(item.child, item);
                }
            }
        };
        let findParentObject = (obj)=>{
            if(obj && obj.parent){
                if(obj.parent.jumpType === "new_blank"){
                    return obj.parent;
                }else{
                    return findParentObject(obj.parent);
                }
            }
            return null;
        };
        let findObject = (object, attr, value)=>{
            if(object){
                if(object instanceof Array){
                    for(let i = 0 ; i < object.length; i++){
                        let item = object[i];
                        let res = findObject(item, attr, value);
                        if(res){
                            return res;
                        }
                    }
                }else if(typeof object === "object"){
                    for(let __attr in object){
                        if(object[__attr] instanceof Array){
                            let res = findObject(object[__attr], attr, value)
                            if(res){
                                return res;
                            }
                        }else{
                            if(__attr === attr && object[attr] === value){
                                return object;
                            }
                        }
                    }
                }
            }
            return null;
        };

        let {hash} = window.location;
        hash = hash.replace("#", "");

        addParentObject(data);
        let menuData = findObject(data, "path", hash);
        if(menuData){
            if(menuData.jumpType === "new_blank"){//new_blank 代表独立子系统
                data = menuData.child;
            }else{
                let parent = findParentObject(menuData);
                if(parent){
                    data = parent.child;
                }
            }
        }

        removeParentObject(data);
        window.cmsitesNavigateData = data;//这里将导航数据保存到缓存中，避免redux更新了route/index.js中的render方法，导致所有组件重新走一次
        console.log("data:   ", data);
        setInfoToLocalStorage("menu", data);
        dispatch({type: LOAD_NAVIGATE_DATA, navigateData: data})
    }
});

function changeNodeStatus(node, currentPath){
    if (!node.id) node.id = uuid();
    let isChecked = false;
    if(node.child && node.child.length > 0){
        for(let i = 0; i < node.child.length; i++){
            let child = node.child[i];
            if(changeNodeStatus(child, currentPath)){
                isChecked = true;
                node.check = true;
                node.status = "down";
            }
        }
    }else{
        if (currentPath !== "/" && node.path === currentPath) {
            isChecked = true;
            node.check = true;
            node.status = "down";
        }
    }
    return isChecked;
}

export const updataNavigateData = (data) => dispatch => dispatch({type: UPDATE_NAVIGATE_DATA, navigateData: data});
export const logout = (msg,isAutoLogOut, callBack=()=>{}) => {
    let url = `/cm-sites-sys/logout`;
    let fun = data=>{
        try {
            data = JSON.parse(data);
            if(typeof(data) == 'object' && data.redirectUrl){
                window.location = data.redirectUrl;
                return;
            }else{
                window.location.href='/cm-sites/pms/framereact/index.html'
            }
        }catch (e) {}
        if(msg){
            message.error(msg)
        }
        callBack();
    };
    request({url,callBack:callBack});
};
export const changeNavigateStauts = () => ({type: CHANGE_NAVIGATE_STAUTS})
export const shrinNavigateStauts = () => ({type: SHRIN_NAVIGATE_STAUTS})
export const autoChangeNavigateStauts = () => ({type: AUTO_CHANGE_NAVIGATE_STAUTS})
export const refreshPage = (refersh) => ({type: REFRESH_PAGE, refersh: refersh});
/**
 * 获取总量数据(访问量，我的发文量)
 * @param dom1
 * @param dom2
 */
export const getTotalPostAmount = (callBack) => {
    request({
        url : "/cm-sites-mmp/integral/getAccessTj",
        callBack: (data)=>{

            callBack(data);
        }
    });
};
/**
 * 获取总量数据(总发文量，总粉丝量，我的发文量)
 * @param dom1
 * @param dom2
 */
export const getNumber  = (callBack) => {
    request({
        url : "/cm-sites-mmp/mf/getPublishTj",
        callBack: (data)=>{
            callBack(data);
        }
    });
};



/**
 * 获取累计发文量(累计，周，日)
 * @param time
 * @param callback
 */
export const getPostMount = (time, callback) => {
    request({
        url : "/cm-sites-mmp/mf/getPublishTj",
        callBack: (data)=>{
            callback(data)
        }
    });
};


/**
 * 获取累计访问量（累计，周，日）
 * @param time
 * @param callback
 */
export const getTrafficCount = (time, callback) => {
    request({
        url : "/cm-sites-mmp/integral/getAccessTj",
        callBack: (data)=>{
            callback(data)
        }
    });
};


/**
 * 获取累计发文量 条形图数据
 * @param time
 * @param callback
 */
export const getYearPostGraph = (callback) => {
    request({
        url : "/cm-sites-mmp/mf/getUserPublishTj",
        callBack: (data)=>{
            callback(data)
        }
    });
};

/**
 * 获取累计访问量 的折线图数据
 * @param time
 * @param callback
 */
export const getYearTrafficGraph = (callback) => {
    request({
        url : "/cm-sites-mmp/integral/getUserLoginInTj",
        callBack: (data)=>{
            callback(data)
        }
    });
};


/**
 * 获取热文排行数据
 * @param time
 * @param callback
 */
export const gethotworldRanking = (time, callback) => {
    request({
        url : "/cm-sites-mmp/mf/news/hotYearlist",
        callBack: (data)=>{
            callback(data)
        }
    });
};

/**
 * 获取热词数据
 * @param time
 * @param callback
 */
export const gethotworldData = (callback) => {
    request({
        url : "/cm-sites-mmp/statistics/hotWords?num=10",
        callBack: (data)=>{
            callback(data)
        }
    });
}


/**
 * 获待我审核列表
 * @param time
 * @param callback
 */
export const myReviewGridData = (param, callback) => {
    fetch("/cm-sites-activiti/activiti/getNeedProcessedAll", {
        headers: {
            ...headers,
            //userName: param.account
        },
        method: 'GET',
        cache: 'no-cache',
        credentials: 'include'
    }).then(response => response.json()).then(data => {
        callback(data)
    })
}


/**
 * 获我的消息列表数据
 * @param time
 * @param callback
 */
export const myMessageGridData = (param, callback) => {
    fetch("/cm-sites-pms/notice/list", {
        method: 'POST',
        cache: 'no-cache',
        headers: headers,
        credentials: 'include',
        body: formateData(param)
    }).then(response => response.json()).then(data => {
        callback(data)
    })
}


/**
 * 获取媒体预约待审列表
 * @param param
 * @param callback
 */
export const myReviewMtyy = (param, callback) => {
    fetch("/cm-sites-pms/internalArrange/getMyneed", {
        method: 'POST',
        cache: 'no-cache',
        headers: headers,
        credentials: 'include'
    }).then(response => response.json()).then(data => {
        callback(data)
    })
}


/**
 * 获取资源统计柱状图的数据
 * @param time
 * @param callback
 */
export const getResouceStaticData = (param, callback) => {
    fetch("/cm-sites-pms/reporter/getResourceStatics?resourceType=" + param.resourceType + "&type=" + param.type, {
        cache: 'no-cache',
        headers: headers,
        credentials: 'include'
    }).then(response => response.json()).then(data => {
        // let data1 = {"resourceType":param.resourceType,"data":data}
        let data1;
        if ('month' === param.type) {

            data1 = {
                "resourceType": param.resourceType,
                "data": data
            }
        } else {
            data1 = {
                "resourceType": param.resourceType,
                "data": data
            };
        }
        callback(data1)
    })
}


/**
 * 获取发布排行榜中的  微信， 微博， 网站数据
 * @param time
 * @param callback
 */
export const getPublishGraphData = (param, callback) => {
    fetch("/cm-sites-pms/website/publishAllMedia", {
        cache: 'no-cache',
        headers: headers,
        credentials: 'include'
    }).then(response => response.json()).then(data => {
        // let data1 = [91, 60, 50]  //按顺序返回的，分别是网站，微信，微博
        callback(data);
    })
}


/**
 * 获取资源库的稿件列表数据
 * @param param
 * @param callback
 */
export const getZykSotryList = (param, callback) => {
    let url = config[applicationName()].zyk + "zyk/storyList"
    post(url, param, callback)
};


/**
 * 获取资源库的图片列表数据
 * @param param
 * @param callback
 */
export const getZykPictureList = (param, callback) => {
    let url = config[applicationName()].zyk + "zyk/pictureList"
    post(url, param, callback);
};


/**
 * 获取资源库的图片列表数据
 * @param param
 * @param callback
 */
export const getContentPictureList = (param, callback) => {
    let url = "/cm-sites-"+applicationName() +"/storyNew/getImagsByResourceIds"
    post(url, param, callback);
};


/**
 * 获取音频的列表数据
 * @param param
 * @param callback
 */
export const getZykAudioList = (param, callback) => {
    let url = config[applicationName()].zyk + "zyk/audioList"
    post(url, param, callback)
};

/**
 * 获取视频列表数据
 * @param param
 * @param callback
 */
export const getZykVideoList = (param, callback) => {
    let url = config[applicationName()].zyk + "zyk/videoList"
    post(url, param, callback)
};

/**
 * 获取文档列表数据
 * @param param
 * @param callback
 */
export const getZykDocumentList = (param, callback) => {
    let url = config[applicationName()].zyk + "zyk/otherFileList"
    post(url, param, callback)
};


/**
 * 获取文档列表数据
 * @param param
 * @param callback
 */
export const getZykStoryDetail = (param, callback) => {
    let url = config[applicationName()].zyk;
    if (param.resourceType === '1') {
        url = url + "zyk/getStoryById";
    } else if (param.resourceType === '6') {
        url = url + "zyk/getStuffById";
    } else {
        url = url + "zyk/getWeiboById";
    }
    let param1 = {
        id: param.id
    };
    post(url, param1, callback)
};


export const getAnalyze = (param, callback) => {
    let url = config[applicationName()].zyk + "zyk/getAnalyze";
    let param1 = {
        str: param.str
    };
    post(url, param1, callback)
};


export function get(url, params, callBack) {
    if (params) {
        let paramsArray = [];
        //拼接参数
        Object.keys(params).forEach(key => paramsArray.push(key + '=' + params[key]))
        if (url.search(/\?/) === -1) {
            url += '?' + paramsArray.join('&')
        } else {
            url += '&' + paramsArray.join('&')
        }
    }

    //fetch请求
    fetch(url, {
        method: 'GET',
        cache: 'no-cache',
        headers: headers,
        credentials: 'include'
    }).then(response => response.json()).then(data => {
        callBack(data);
    }).catch((error) => {
        // alert(error)
    })
}

/**
 * 参数转换
 * @param data
 * @returns {string}
 */
export function getBatchDownloadPath(params,callBack) {
    post("/cm-sites-" + applicationName() + "/storage/batchDownload", params, callBack);
}

/**
 * 获取我的下载列表数据
 * @param data
 * @returns {string}
 */
export function getDownloadTask(params,callBack) {
    post("/cm-sites-" + applicationName() + "/storage/getDownloadTask", params, callBack);
}

/**
 * 更具任务id,删除任务
 * @param data
 * @returns {string}
 */
export function deDownloadTask(params,callBack) {
    get("/cm-sites-" + applicationName() + "/storage/deDownloadTask/"+params, params, callBack);
}


export function post(url, params, callBack) {
    //fetch请求

    fetch(url, {
        method: 'post',
        cache: 'no-cache',
        body: formateData(params),
        headers: headers,
        credentials: 'include'
    }).then(response => response.json()).then(data => {
        callBack(data);
    }).catch((error) => {
        // alert(error)
    })
}


export function jsonPost(url, params, callBack) {
    //fetch请求

    fetch(url, {
        method: 'post',
        cache: 'no-cache',
        body: params,
        headers: headerJson,
        credentials: 'include'
    }).then(response => response.json()).then(data => {
        callBack(data);
    }).catch((error) => {
        // alert(error)
    })
}

/**
 * 参数转换
 * @param data
 * @returns {string}
 */
export function formateData(data) {
    if(!data)
        return {};
    const result = Object.entries(data).map(([key, value]) =>
        key+'='+value).join('&');
    return result;
}


/**写稿处资源库搜索内容修改*/
export const changZykSearchText = (searchText, onlyMe, tableKey, doSearch) => ({
    type: CHANG_ZYK_SEARCH_TEXT,
    searchText,
    onlyMe,
    tableKey,
    doSearch
});

/**资源库稿件的总数*/
export const changZykStoryCount = (zykStoryCount) => ({type: ZYK_STORY_COUNT, zykStoryCount});

/**资源库图片的总数*/
export const changZykPictureCount = (zykPictureCount) => ({type: ZYK_PICTURE_COUNT, zykPictureCount});

/**资源库音频的总数*/
export const changZykAudioCount = (zykAudioCount) => ({type: ZYK_AUDIO_COUNT, zykAudioCount});

/**稿件内容图片的总数*/
export const contentPictureCount = (zykContentPictureCount) => ({type: CONTENT_PICTURE_COUNT, zykContentPictureCount});

/**资源库视频的总数*/
export const changZykVideoCount = (zykVideoCount) => ({type: ZYK_VIDEO_COUNT, zykVideoCount});

/**获取未读消息的数量*/
export const getUnReadMessageCount = (messageCount) => ({type: UN_READ_MESSAGE_COUNT, messageCount});

/**资源库文档的总数*/
export const changZykDocumentCount = (zykDocumentCount) => ({type: ZYK_DOCUMENT_COUNT, zykDocumentCount});
/**获取当前websocket通道名称*/
export const wsName = (successCallback, eorrorCallBack) => fetch(config[applicationName()].wsURL, {
    cache: 'no-cache',
    headers: headers,
    credentials: 'include'//浏览器发送cookie,解决的问题就是登录之后被踢了
})
    .then(response => response.json())
    .then(data => {
        successCallback(data);
    }).catch((error) => {
        eorrorCallBack(error);
});

/**ws监听方法*/
export const websocketListen = (url,successCallback) => fetch(url, {
    cache: 'no-cache',
    headers: headers,
    credentials: 'include'//浏览器发送cookie,解决的问题就是登录之后被踢了
}).then(response => {
    if ((response.url!== "" && response.url.indexOf(url) === -1) || response.status === 503)
    {
		console.log("response==websocketListen=======", response);
        console.log("config[applicationName()].loginPage=======", config[applicationName()].loginPage);
        window.location = config[applicationName()].loginPage;
    } else {
        return response;
    }
})
    .then(response => response.text())
    .then(res =>{
        try {
            let data = JSON.parse(res);
            setTimeout(()=>successCallback(data), 0);
            websocketListen(url,successCallback);
        }catch (error) {
            console.log("error=======websocketListen====", error);
            setTimeout(()=>successCallback(res), 0);
            websocketListen(url,successCallback);
        }
    }).catch((error) =>{
        console.log("error==catch=====websocketListen====", error);
		//websocketListen(url,successCallback);
    });

export const postAct = ( url,params,callback) => fetch(url, {
    method: "post",
    cache: 'no-cache',
    headers: {
        ...headers,
        userName: params.account
    },
    body: formateData(params),
    credentials: 'include'//浏览器发送cookie,解决的问题就是登录之后被踢了
})
.then(response => response.json())
.then(data => {
    callback(data);
});

export const postPublic = ( url,params,callback) => fetch(url, {
    method: "post",
    cache: 'no-cache',
    headers: headers,
    body: formateData(params),
    credentials: 'include'//浏览器发送cookie,解决的问题就是登录之后被踢了
})
    .then(response => response.json())
    .then(data => {
        callback(data);
    });

//获取栏目权限
export const getMediaRoleByColum = (params, callBack) => {  //保存图片
    request("/cm-sites-" + applicationName() + '/'+'mediaTreeActiviti/getMediaRoleByColum','post', params, callBack)
};

export const storySort = (params,callback) => fetch("/cm-sites-" + applicationName() + "/storyNew/storySort", {
    method: "post",
    cache: 'no-cache',
    headers: {
        ...headers,
        "Content-Type": "application/json"
    },
    body: JSON.stringify({list:params}),
    credentials: 'include'//浏览器发送cookie,解决的问题就是登录之后被踢了
}).then(response => response.json())
.then(data => {
    callback(data);
});


export const doTop = (params,callback) => fetch("/cm-sites-" + applicationName() + "/storyNew/doTop", {
    method: "post",
    cache: 'no-cache',
    body: createFromData(params),
    credentials: 'include'//浏览器发送cookie,解决的问题就是登录之后被踢了
}).then(response => response.json())
    .then(data => {
        callback(data);
});

export const updateNewsStatus = (params,callback) => fetch("/cm-sites-" + applicationName() + "/storyNew/updateNewsStatus", {
    method: "post",
    cache: 'no-cache',
    body:createFromData(params),
    credentials: 'include'//浏览器发送cookie,解决的问题就是登录之后被踢了
}).then(response => response.json())
    .then(data => {
        callback(data)
    });

export const setImportance = (params,callback) => fetch("/cm-sites-" + applicationName() + "/storyNew/setImportance", {
    method: "post",
    cache: 'no-cache',
    body: createFromData(params),
    credentials: 'include'//浏览器发送cookie,解决的问题就是登录之后被踢了
}).then(response => response.json())
    .then(data => {
        callback(data);
    });

//String mediaCode, String businessIds （  \ 隔开  ）
export const undo = (params,callback) => fetch("/cm-sites-" + applicationName() + "/storyNew/undo", {
    method: "post",
    cache: 'no-cache',
    body: createFromData(params),
    credentials: 'include'//浏览器发送cookie,解决的问题就是登录之后被踢了
}).then(response => response.json())
    .then(data => {
        callback(data);
    });

export const restoredo = (params,callback) => fetch("/cm-sites-" + applicationName() + "/storyNew/restore", {
    method: "post",
    cache: 'no-cache',
    body: createFromData(params),
    credentials: 'include'//浏览器发送cookie,解决的问题就是登录之后被踢了
}).then(response => response.json())
    .then(data => {
        callback(data);
    });

export const websiteDomainURLdo = (params,callback) => fetch("/cm-sites-" + applicationName() + "/website/getWebsiteDomain", {
    method: "post",
    cache: 'no-cache',
    body: createFromData(params),
    credentials: 'include'//浏览器发送cookie,解决的问题就是登录之后被踢了
}).then(response => response.text())
    .then(data => {
        callback(data);
    });

export const judgeBindVsbAccountdo = (params,callback) => fetch("/cm-sites-" + applicationName() + "/user/judgeBindVsbAccount", {
    method: "post",
    cache: 'no-cache',
    body: createFromData(params),
    credentials: 'include'//浏览器发送cookie,解决的问题就是登录之后被踢了
}).then(response => response.json())
    .then(data => {
        callback(data);
    });

export const loginVsbdo = (params,callback) => fetch("/cm-sites-" + applicationName() + "/user/loginVsb", {
    method: "post",
    cache: 'no-cache',
    body: createFromData(params),
    credentials: 'include'//浏览器发送cookie,解决的问题就是登录之后被踢了
}).then(response => response.json())
    .then(data => {
        callback(data);
    });

export const deletestorydo = (params,callback) => fetch("/cm-sites-" + applicationName() + "/storyNew/delAllStory", {
    method: "post",
    cache: 'no-cache',
    body: createFromData(params),
    credentials: 'include'//浏览器发送cookie,解决的问题就是登录之后被踢了
}).then(response => response.json())
    .then(data => {
        callback(data);
    });
//根据id要获取资源的详情
export const getresources = (params,callback) => fetch("/cm-sites-" + applicationName() + "/storyNew/resources?storyId="+params, {
    method: "get",
    cache: 'no-cache',
    credentials: 'include'//浏览器发送cookie,解决的问题就是登录之后被踢了
}).then(response => response.json())
    .then(data => {
        callback(data);
    });
//根据md5 删除资源。
export const delStoryById = (params,callback) => fetch("/cm-sites-" + applicationName() + "/storyNew/delStoryById", {
    method: "post",
    cache: 'no-cache',
    body: createFromData(params),
    credentials: 'include'//浏览器发送cookie,解决的问题就是登录之后被踢了
}).then(response => response.text())
    .then(data => {
        callback(data);
    });

//删除稿件
export const delMoveFileToRecycle = (params,callback) => fetch("/cm-sites-" + applicationName() + "/storage/deleteFileAndMoveFileToRecycle", {
    method: "post",
    cache: 'no-cache',
    body: createFromData(params),
    credentials: 'include'//浏览器发送cookie,解决的问题就是登录之后被踢了
}).then(response => response.text())
    .then(data => {
        callback(data);
    });

//销毁稿件 稿件submitter变为当前账号  状态变为草稿
export const destructByStoryId = (params,callback) => fetch("/cm-sites-" + applicationName() + "/storyNew/destructByStoryId", {
    method: "post",
    cache: 'no-cache',
    body: createFromData(params),
    credentials: 'include'//浏览器发送cookie,解决的问题就是登录之后被踢了
}).then(response => response.text())
    .then(data => {
        callback(data);
    });


export function  createFromData(params){
    let formData = new FormData();
    for(let key in params){
        formData.append(key,params[key]);
    }
    return formData;
}


export const beginAuthURL = () => fetch(config[applicationName()].beginAuthURL, {
    cache: 'no-cache',
    headers: headers,
    credentials: 'include'//浏览器发送cookie,解决的问题就是登录之后被踢了
});
export const updateNavigateLevel2Data = (title, data) => ({type:UPDATE_NAVIGATE_LEVEL2_DATA, navigateLevel2Title: title,navigateLevel2Data:data});
export const updateStoryParams = (params, columns) => ({type:"UPDATE_STORY_PARAMS", params:params,columns:columns});

export const getCurrentUser = (callback) => fetch("/cm-sites-" + applicationName() + "/user/getCurrentUser", {
    method: "post",
    cache: 'no-cache',
    credentials: 'include'//浏览器发送cookie,解决的问题就是登录之后被踢了
}).then(response => response.json())
.then(data => {
    callback(data);
}).catch((error) => {
    console.error("actionError:getCurrentUser",error);
    callback({});
});

export const getInterViewTitle = (interviewId,index,callback) => fetch("/cm-sites-" + applicationName() + "/interview/getInterViewTitleById", {
    method: 'post',
    cache: 'no-cache',
    headers: headers,
    credentials: 'include',
    body: formateData({interviewId})
}).then(response => response.text())
    .then(data => {
        callback(index,data);
    }).catch((error) => {
        console.error("actionError:getCurrentUser",error);
        callback({});
    });
/**
 * 获取所有的  文件配置路径数据
 * @param params
 * @param callBack
 */
export function getAllfileUploadConfig(body, callBack) {
    request({url:`/cm-sites-${applicationName()}/fileUploadPathConfig/getFileUploadPathConfigs`,body, callBack});
}

/**
 * 保存  文件配置路径数据
 * @param params
 * @param callBack
 */
export function saveFileUploadPathConfig(body, callBack) {
    request({url:`/cm-sites-${applicationName()}/fileUploadPathConfig/saveFileUploadPathConfig`,body, callBack});
}

/**
 * 初始化，资源路径配置的基础数据
 * @param params
 * @param callBack
 */
export function initFileUploadPathConfigs(body, callBack) {
    request({url:`/cm-sites-${applicationName()}/fileUploadPathConfig/initFileUploadPathConfigs`,body, callBack});
}

/**
 * 获取基础数据表信息
 * @param params
 * @param callBack
 */
export function getBaseDataInfos(body, callBack) {
    request({url:`/cm-sites-${applicationName()}/getBaseTable`, body, callBack});
}

/**
 * 设置pmd端消息已读状态
 * @param params
 * @param callBack
 */
export function setReadMessageStatus(body, callBack) {
    request({url:`/cm-sites-${applicationName()}/notice/setReadMessageStatus`, body, callBack});
}


/**
 * 获取未读消息的数量
 * @param params
 * @param callBack
 */
export function getUnreadCount(body, callBack) {
    request({url:`/cm-sites-${applicationName()}/notice/getUnReadMsgCount`,body, callBack});
}

/**
 * 发送邮件
 * @param params
 * @param callBack
 */
export function sendEmail(body, callBack) {
    request({url:`/cm-sites-${applicationName()}/storyNew/sendMail`,body, callBack});
}

/**
 * 发送邮件
 * @param params
 * @param callBack
 */
export function getByConfigKey(body, callBack) {
    request({url:`/cm-sites-${applicationName()}/config/getByConfigKey`,body, callBack});
}


/**
 * 获取基础数据表信息
 * @param params
 * @param callBack
 */
export function importBaseData(body, callBack) {
    request({url:`/cm-sites-${applicationName()}/importBaseData`,body, callBack});
}


/**
 * 获取基础数据表信息
 * @param params
 * @param callBack
 */
export function saveStoryFilePicture(params, callBack) {
    jsonPost("/cm-sites-"+ applicationName() +"/storyNew/saveStoryFilePicture", params, callBack);
}

/**
 * 保存投稿端的图片信息
 * @param params
 * @param callBack
 */
export function saveContributeStoryFilePicture(params, callBack) {
    post("/cm-sites-"+ applicationName() +"/storyNew/saveStoryFilePicture", params, callBack);
}

/**
 * 获取存放在sessionStorage中属性前缀
 * 解决多个用户登录问题，目前按照不同的端可以在同一个浏览器中登录
 */
const getStorageAttrPrev = ()=>{
    let prev = window.location.href.replace(/(https?:\/\/[^\/]*).*cm-sites\/([^\/]*).*/, "$1_$2").replace(/[:\/\.]/g, "_");
    if(prev){
        return prev + "_";
    }
    throw new Error("前端storage出错，获取prev失败！");
};

/**
 * 保存信息到sessionStorage
 */
export const setInfoToLocalStorage = (attr, value) => {
    // console.log('setInfoToLocalStorage', attr, value);
    attr = getStorageAttrPrev() + attr;
    sessionStorage.setItem(attr, JSON.stringify(value));
}


/**
 * 移除信息fromSessionStorage
 */
export const removeInfoFromLocalStorage = (attr) => {
    attr = getStorageAttrPrev() + attr;
    sessionStorage.removeItem(attr);
}


/**
 * 获取信息fromSessionStorage
 */
export const getInfoFromLocalStorage = (attr) => {
    attr = getStorageAttrPrev() + attr;
    let res = sessionStorage.getItem(attr);
    if(res === null){
        return null;
    }
    return JSON.parse(sessionStorage.getItem(attr));
};


/**
 * 清空 sessionStorage
 */
export const clearLocalStorage = () => {
    sessionStorage.clear();
}

/**
 * 获取稿件类型
 * @param params
 * @param callBack
 */
export function getStoryType(params, callBack) {
    fetch("/cm-sites-"+applicationName() +"/activiti/getStoryType", {
        method: 'post',
        cache: 'no-cache',
        body: formateData(params),
        headers: headers,
        credentials: 'include'
    }).then(response => response.text()).then(data => {
        callBack(data);
    }).catch((error) => {
        // alert(error)
    })
}

/**
 * 获取所有部门
 */
export const getDeptTree = ()=>{
    return new Promise((resolve, reject) => {
        window.$.ajax({
            type:"post",
            url: "/cm-sites-"+applicationName() +"/dept/getDeptTree",
            dataType:"json",
            success:function (result) {
                resolve(result);
            },
            error:function (e) {
                console.error(e);
                reject(e);
            }
        });
    });
};

/**
 * 获取excel导出模型
 * @param param
 * @param call
 */
export  const getAllModel=(param,call)=>{
    get("/cm-sites-pms/excel/getAllModel",{},call);
}

/**
 * 获取excel导出模型
 * @param param
 * @param call
 */
export  const exportBusData=(param,call)=>{
    get("/cm-sites-" + applicationName() + "/excel/exportByModelKey",param,call);
}

/**
 * 根据媒体ids获取媒体列表
 */
export const getMediaByIds = (ids)=>{
    return new Promise((resolve, reject) => {
        window.$.ajax({
            type:"post",
            url: "/cm-sites-"+applicationName() +"/media/getMediaByIds",
            dataType:"json",
            data:{
                ids
            },
            traditional: true,//参数中有数组，防止深度序列化
            success:function (result) {
                resolve(result);
            },
            error:function (e) {
                console.error(e);
                reject(e);
            }
        });
    });
};

/**
 * 获取当前用户的所有权限；
 * @type {Function}
 */
export const getUserAllAuth = ((param, callBack) => {
    get("/cm-sites-"+applicationName() + "/user/getAllAuth", param, callBack);
});

/**
 * 获取流程中代办人员
 */
export const getCandidateByUuid = (uuid)=>{
    return new Promise((resolve, reject) => {
        window.$.ajax({
            type:"post",
            url: "/cm-sites-activiti/activitiAdmin/getCandidateByUuid",
            dataType:"json",
            data:{
                uuid
            },
            success:function (result) {
                resolve(result);
            },
            error:function (e) {
                console.error(e);
                reject(e);
            }
        });
    });
};

export const getButtonByMediaCode = (mediaRoleItems, callBack)=> {
    let url = "/cm-sites-pms/mediaTreeActiviti/getMediaRoleByColum";
    fetch(url, {
        method: 'post',
        cache: 'no-cache',
        headers: {
            ...headers,
            'Content-Type': 'application/json; charset=UTF-8'
        },
        credentials: 'include',
        body: JSON.stringify(mediaRoleItems)
    }).then(response => response.json()).then(data => {
        callBack(data);
    }).catch((error) => {
        console.error("actionError:getWeiboButtonByMediaCode",error);
        callBack("");
    })
};

/**校验是否登录*/
export const isLogin = ()=> new Promise((resolve, reject) => {
    window.$.ajax({
        cache: true,
        type: "post",
        url: "/cm-sites-"+applicationName()+"/islogin",
        dataType:"json",
        success:function (result) {
            resolve(result===true);
        },
        error:function (e) {
            console.error(e);
            reject(false);
        }
    });
});
